import { render } from "./InventarioFisicoPage.vue?vue&type=template&id=cdf1d656&scoped=true"
import script from "./InventarioFisicoPage.vue?vue&type=script&lang=js"
export * from "./InventarioFisicoPage.vue?vue&type=script&lang=js"

import "./InventarioFisicoPage.vue?vue&type=style&index=0&id=cdf1d656&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdf1d656"]])

export default __exports__